import React from "react";
import "react-day-picker/dist/style.css";
import { DayPicker } from "react-day-picker";

const DatePicker = ({
  onClose,
  details,
  onOkClick,
  selectedDate,
  onSelectDate
}) => {
  return (
    <div className="date-picker-modal" onClick={onClose}>
      <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
        <DayPicker
          mode="single"
          required
          selected={selectedDate}
          onSelect={(date) => {
            onSelectDate(date);
          }}
          className="calender-months"
          fromDate={new Date(details.start_date)}
          toDate={new Date(details.end_date)}
        />
        <div className="date-footer">
          <div className="footer-btn" onClick={onOkClick}>
            OK
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
